import * as yup from 'yup';

import { FormErrors } from '@blockpulse3/data/shared';

export const schema = yup
  .object({
    currentPassword: yup.string().required(FormErrors.RequiredField),
    newPassword: yup.string().min(8, FormErrors.PasswordFormat).required(FormErrors.RequiredField),
    confirm: yup
      .string()
      .oneOf([yup.ref('newPassword'), '', undefined], 'PASSWORD_MATCH')
      .required(FormErrors.RequiredField),
  })
  .required();
